// Sample data for the agenda prototype — Fede's 8-day trip as the brain planned it (replay of 2026-10-07).
// Not wired to the backend: the real agenda will receive the same shape from the preview.
const AGENDA_DEMO = {
 "demo": true,
 "trip": {
  "title": "Tokyo & Kyoto · 8 days",
  "start": "2026-05-05",
  "dayStart": "08:00",
  "dayEnd": "22:30"
 },
 "days": [
  {
   "n": 1,
   "date": "2026-05-05",
   "city": "Tokyo",
   "title": "Shibuya lights and Shinjuku lanes",
   "blocks": [
    {
     "kind": "evening",
     "area": "Shibuya",
     "places": [
      {
       "id": "shibuya-crossing",
       "name": "Shibuya Crossing",
       "category": "popular",
       "area": "Shibuya",
       "lat": 35.659495,
       "lng": 139.700498,
       "minutes": 20,
       "open": "00:00-24:00",
       "best": "17:00-20:00",
       "image": "/places/shibuya-crossing.jpg",
       "city": "Tokyo"
      }
     ],
     "options": [],
     "times": [
      [
       "17:30",
       "17:50"
      ]
     ],
     "transit_next": null
    },
    {
     "kind": "dinner",
     "area": "Shibuya",
     "places": [],
     "options": [
      {
       "id": "ichiran-ramen-shibuya",
       "name": "Ichiran — Shibuya",
       "category": "food",
       "area": "Shibuya",
       "lat": 35.661129,
       "lng": 139.700988,
       "minutes": 45,
       "open": "00:00-24:00",
       "best": "06:00-10:00",
       "image": "/places/ichiran-ramen-shibuya.jpg",
       "city": "Tokyo"
      },
      {
       "id": "uobei-shibuya-dogenzaka",
       "name": "Uobei Shibuya Dogenzaka",
       "category": "food",
       "area": "Shibuya",
       "lat": 35.659473,
       "lng": 139.697754,
       "minutes": 38,
       "open": "11:00-23:00",
       "best": "11:00-14:30",
       "image": null,
       "city": "Tokyo"
      }
     ],
     "times": [
      [
       null,
       null
      ],
      [
       null,
       null
      ]
     ],
     "transit_next": {
      "minutes": 18,
      "method": "metro"
     }
    },
    {
     "kind": "evening",
     "area": "Shinjuku",
     "places": [
      {
       "id": "shinjuku-golden-gai",
       "name": "Shinjuku Golden Gai",
       "category": "nightlife",
       "area": "Shinjuku",
       "lat": 35.69399,
       "lng": 139.7047,
       "minutes": 75,
       "open": "19:00-05:00",
       "best": "20:00-24:00",
       "image": "/places/shinjuku-golden-gai.jpg",
       "city": "Tokyo"
      }
     ],
     "options": [],
     "times": [
      [
       "20:30",
       "21:45"
      ]
     ],
     "transit_next": null
    }
   ]
  },
  {
   "n": 2,
   "date": "2026-05-06",
   "city": "Tokyo",
   "title": "Fuji, framed and floating",
   "blocks": [
    {
     "kind": "morning",
     "area": "Fujiyoshida & Kawaguchiko, Yamanashi",
     "places": [
      {
       "id": "mount-fuji-chureito-kawaguchiko",
       "name": "Mount Fuji: Chureito Pagoda & Lake Kawaguchiko",
       "category": "popular",
       "area": "Fujiyoshida & Kawaguchiko, Yamanashi",
       "lat": 35.5004871,
       "lng": 138.80082,
       "minutes": 300,
       "open": "00:00-24:00",
       "best": null,
       "image": "/places/mount-fuji-chureito-kawaguchiko.jpg",
       "city": "Tokyo"
      }
     ],
     "options": [],
     "times": [
      [
       "08:00",
       "13:00"
      ]
     ],
     "transit_next": null
    },
    {
     "kind": "dinner",
     "area": "Tokyo",
     "places": [],
     "options": [
      {
       "id": "rokurinsha",
       "name": "Rokurinsha",
       "category": "food",
       "area": "Tokyo Station",
       "lat": 35.680375,
       "lng": 139.767877,
       "minutes": 40,
       "open": "07:30-09:45,10:00-23:00",
       "best": "07:30-09:30",
       "image": "/places/rokurinsha.jpg",
       "city": "Tokyo"
      },
      {
       "id": "tempura-kondo",
       "name": "Tempura Kondo",
       "category": "food",
       "area": "Ginza",
       "lat": 35.671177,
       "lng": 139.763092,
       "minutes": 120,
       "open": "12:00-15:00,17:00-20:30",
       "best": "12:00-14:30",
       "image": null,
       "city": "Tokyo"
      }
     ],
     "times": [
      [
       null,
       null
      ],
      [
       null,
       null
      ]
     ],
     "transit_next": null
    }
   ]
  },
  {
   "n": 3,
   "date": "2026-05-07",
   "city": "Tokyo",
   "title": "Asakusa",
   "blocks": [
    {
     "kind": "morning",
     "area": "Asakusa",
     "places": [
      {
       "id": "senso-ji-temple",
       "name": "Senso-ji Temple",
       "category": "culture",
       "area": "Asakusa",
       "lat": 35.713403,
       "lng": 139.795527,
       "minutes": 75,
       "open": "06:00-17:00",
       "best": "06:00-08:30",
       "image": "/places/senso-ji-temple.jpg",
       "city": "Tokyo"
      },
      {
       "id": "nakamise-dori",
       "name": "Nakamise-dori",
       "category": "popular",
       "area": "Asakusa",
       "lat": 35.712521,
       "lng": 139.796517,
       "minutes": 40,
       "open": "10:00-17:00",
       "best": "10:00-11:00",
       "image": "/places/nakamise-dori.jpg",
       "city": "Tokyo"
      }
     ],
     "options": [],
     "times": [
      [
       "08:00",
       "09:15"
      ],
      [
       "10:00",
       "10:40"
      ]
     ],
     "transit_next": {
      "minutes": 29,
      "method": "transit · check route"
     }
    },
    {
     "kind": "morning",
     "area": "Akihabara",
     "places": [
      {
       "id": "at-home-cafe-akihabara-main",
       "name": "at-home cafe · Akihabara Main",
       "category": "special",
       "area": "Akihabara",
       "lat": 35.701459,
       "lng": 139.772579,
       "minutes": 60,
       "open": null,
       "best": "11:00-21:00",
       "image": null,
       "city": "Tokyo"
      }
     ],
     "options": [],
     "times": [
      [
       "11:30",
       "12:30"
      ]
     ],
     "transit_next": null
    },
    {
     "kind": "lunch",
     "area": "Akihabara",
     "places": [],
     "options": [
      {
       "id": "kanda-yabu-soba",
       "name": "Kanda Yabusoba",
       "category": "food",
       "area": "Kanda",
       "lat": 35.69702,
       "lng": 139.76867,
       "minutes": 60,
       "open": "11:30-20:00",
       "best": "11:30-14:00",
       "image": "/places/kanda-yabu-soba.jpg",
       "city": "Tokyo"
      },
      {
       "id": "houraiya",
       "name": "Houraiya",
       "category": "food",
       "area": "Ueno & Okachimachi",
       "lat": 35.707416,
       "lng": 139.773758,
       "minutes": 55,
       "open": "11:30-14:30",
       "best": "11:30-14:00",
       "image": null,
       "city": "Tokyo"
      }
     ],
     "times": [
      [
       null,
       null
      ],
      [
       null,
       null
      ]
     ],
     "transit_next": {
      "minutes": 30,
      "method": "train"
     }
    },
    {
     "kind": "afternoon",
     "area": "Yanaka",
     "places": [
      {
       "id": "yanaka-ginza",
       "name": "Yanaka Ginza",
       "category": "hidden_gem",
       "area": "Yanaka",
       "lat": 35.727669,
       "lng": 139.765317,
       "minutes": 45,
       "open": "10:00-18:00",
       "best": "15:00-17:30",
       "image": "/places/yanaka-ginza.jpg",
       "city": "Tokyo"
      },
      {
       "id": "yanaka-cemetery",
       "name": "Yanaka Cemetery",
       "category": "culture",
       "area": "Yanaka",
       "lat": 35.724368,
       "lng": 139.771136,
       "minutes": 45,
       "open": "00:00-23:59",
       "best": "08:00-11:00",
       "image": "/places/yanaka-cemetery.jpg",
       "city": "Tokyo"
      }
     ],
     "options": [],
     "times": [
      [
       "14:40",
       "15:25"
      ],
      [
       "15:40",
       "16:25"
      ]
     ],
     "transit_next": {
      "minutes": 33,
      "method": "train"
     }
    },
    {
     "kind": "evening",
     "area": "Ginza",
     "places": [
      {
       "id": "bar-high-five",
       "name": "Bar High Five",
       "category": "nightlife",
       "area": "Ginza",
       "lat": 35.671596,
       "lng": 139.762937,
       "minutes": 75,
       "open": "17:00-01:00",
       "best": "17:00-21:00",
       "image": "/places/bar-high-five.jpg",
       "city": "Tokyo"
      }
     ],
     "options": [],
     "times": [
      [
       "17:30",
       "18:45"
      ]
     ],
     "transit_next": {
      "minutes": 28,
      "method": "metro"
     }
    },
    {
     "kind": "evening",
     "area": "Shinjuku",
     "places": [
      {
       "id": "omoide-yokocho",
       "name": "Omoide Yokocho",
       "category": "nightlife",
       "area": "Shinjuku",
       "lat": 35.693016,
       "lng": 139.699697,
       "minutes": 75,
       "open": "17:00-00:00",
       "best": "18:00-21:00",
       "image": "/places/omoide-yokocho.jpg",
       "city": "Tokyo"
      }
     ],
     "options": [],
     "times": [
      [
       "19:20",
       "20:35"
      ]
     ],
     "transit_next": null
    },
    {
     "kind": "dinner",
     "area": "Shinjuku",
     "places": [],
     "options": [
      {
       "id": "nabezou",
       "name": "MO-MO-PARADISE Shinjuku 3-chome",
       "category": "food",
       "area": "Shinjuku",
       "lat": 35.690884,
       "lng": 139.704836,
       "minutes": 90,
       "open": "11:30-15:00,17:00-22:30",
       "best": "17:00-21:00",
       "image": "/places/nabezou.jpg",
       "city": "Tokyo"
      },
      {
       "id": "nagi-shinjuku-golden-gai",
       "name": "Nagi Shinjuku Golden Gai",
       "category": "food",
       "area": "Shinjuku",
       "lat": 35.69376,
       "lng": 139.704557,
       "minutes": 40,
       "open": "00:00-24:00",
       "best": "14:00-17:00",
       "image": "/places/nagi-shinjuku-golden-gai.jpg",
       "city": "Tokyo"
      }
     ],
     "times": [
      [
       null,
       null
      ],
      [
       null,
       null
      ]
     ],
     "transit_next": null
    }
   ]
  },
  {
   "n": 4,
   "date": "2026-05-08",
   "city": "Kyoto",
   "title": "Shibuya",
   "blocks": [
    {
     "kind": "morning",
     "area": "Shibuya",
     "places": [
      {
       "id": "meiji-jingu-shrine",
       "name": "Meiji Jingu Shrine",
       "category": "culture",
       "area": "Harajuku & Omotesando",
       "lat": 35.674842,
       "lng": 139.699627,
       "minutes": 75,
       "open": "05:00-18:00",
       "best": "08:00-10:00",
       "image": "/places/meiji-jingu-shrine.jpg",
       "city": "Tokyo"
      }
     ],
     "options": [],
     "times": [
      [
       "08:00",
       "09:15"
      ]
     ],
     "transit_next": {
      "minutes": 8,
      "method": "walk"
     }
    },
    {
     "kind": "morning",
     "area": "Harajuku & Omotesando",
     "places": [
      {
       "id": "takeshita-street",
       "name": "Takeshita Street",
       "category": "popular",
       "area": "Harajuku & Omotesando",
       "lat": 35.671161,
       "lng": 139.704955,
       "minutes": 45,
       "open": "11:00-18:00",
       "best": "11:00-13:00",
       "image": "/places/takeshita-street.jpg",
       "city": "Tokyo"
      }
     ],
     "options": [],
     "times": [
      [
       "11:10",
       "11:55"
      ]
     ],
     "transit_next": null
    },
    {
     "kind": "travel",
     "label": "Nozomi Shinkansen, Tokaido line",
     "text": "Traveling: Tokyo → Kyoto"
    },
    {
     "kind": "evening",
     "area": "Fushimi",
     "places": [
      {
       "id": "fushimi-inari-taisha",
       "name": "Fushimi Inari Taisha",
       "category": "culture",
       "area": "Fushimi Inari",
       "lat": 34.967142,
       "lng": 135.773236,
       "minutes": 120,
       "open": "00:00-24:00",
       "best": "05:30-09:00",
       "image": "/places/fushimi-inari-taisha.jpg",
       "city": "Kyoto"
      }
     ],
     "options": [],
     "times": [
      [
       "17:45",
       "19:45"
      ]
     ],
     "transit_next": null
    },
    {
     "kind": "dinner",
     "area": "Fushimi",
     "places": [],
     "options": [
      {
       "id": "gion-tanto",
       "name": "Gion Tanto",
       "category": "food",
       "area": "Gion",
       "lat": 35.00553,
       "lng": 135.774574,
       "minutes": 60,
       "open": "16:30-21:30",
       "best": "12:00-14:00,17:00-19:00",
       "image": null,
       "city": "Kyoto"
      }
     ],
     "times": [
      [
       null,
       null
      ]
     ],
     "transit_next": null
    }
   ]
  },
  {
   "n": 5,
   "date": "2026-05-09",
   "city": "Kyoto",
   "title": "Higashiyama",
   "blocks": [
    {
     "kind": "morning",
     "area": "Higashiyama",
     "places": [
      {
       "id": "keage-incline",
       "name": "Keage Incline",
       "category": "hidden_gem",
       "area": "Philosopher's Path & Nanzen-ji",
       "lat": 35.009443,
       "lng": 135.789618,
       "minutes": 35,
       "open": "00:00-24:00",
       "best": "06:00-18:00",
       "image": "/places/keage-incline.jpg",
       "city": "Kyoto"
      },
      {
       "id": "sannenzaka-and-ninenzaka",
       "name": "Sannenzaka & Ninenzaka",
       "category": "culture",
       "area": "Higashiyama",
       "lat": 34.998448,
       "lng": 135.78084,
       "minutes": 50,
       "open": "00:00-23:59",
       "best": "07:30-10:00",
       "image": "/places/sannenzaka-and-ninenzaka.jpg",
       "city": "Kyoto"
      },
      {
       "id": "kennin-ji",
       "name": "Kennin-ji",
       "category": "culture",
       "area": "Gion",
       "lat": 35.000257,
       "lng": 135.773741,
       "minutes": 75,
       "open": "10:00-17:00",
       "best": "10:00-12:00",
       "image": "/places/kennin-ji.jpg",
       "city": "Kyoto"
      },
      {
       "id": "yasaka-shrine",
       "name": "Yasaka Shrine",
       "category": "popular",
       "area": "Gion",
       "lat": 35.003603,
       "lng": 135.778261,
       "minutes": 40,
       "open": "00:00-23:59",
       "best": "19:00-21:30",
       "image": "/places/yasaka-shrine.jpg",
       "city": "Kyoto"
      }
     ],
     "options": [],
     "times": [
      [
       "08:00",
       "08:35"
      ],
      [
       "09:10",
       "10:00"
      ],
      [
       "10:15",
       "11:30"
      ],
      [
       "11:50",
       "12:30"
      ]
     ],
     "transit_next": null
    },
    {
     "kind": "lunch",
     "area": "Higashiyama",
     "places": [],
     "options": [
      {
       "id": "tousuiro-higashiyama",
       "name": "Tousuiro Gion",
       "category": "food",
       "area": "Gion",
       "lat": 35.000393,
       "lng": 135.777004,
       "minutes": 95,
       "open": "11:30-15:00,17:00-21:00",
       "best": "11:30-14:00",
       "image": null,
       "city": "Kyoto"
      },
      {
       "id": "gion-duck-noodle",
       "name": "Gion Duck Noodles — Gion",
       "category": "food",
       "area": "Gion",
       "lat": 35.004366,
       "lng": 135.777603,
       "minutes": 60,
       "open": "11:00-21:00",
       "best": "11:00-11:30",
       "image": "/places/gion-duck-noodle.jpg",
       "city": "Kyoto"
      }
     ],
     "times": [
      [
       null,
       null
      ],
      [
       null,
       null
      ]
     ],
     "transit_next": {
      "minutes": 7,
      "method": "walk"
     }
    },
    {
     "kind": "afternoon",
     "area": "Gion",
     "places": [
      {
       "id": "hanamikoji-dori",
       "name": "Hanamikoji-dori",
       "category": "culture",
       "area": "Gion",
       "lat": 35.008015,
       "lng": 135.775464,
       "minutes": 25,
       "open": "00:00-23:59",
       "best": "16:30-19:00",
       "image": "/places/hanamikoji-dori.jpg",
       "city": "Kyoto"
      }
     ],
     "options": [],
     "times": [
      [
       "14:25",
       "14:50"
      ]
     ],
     "transit_next": {
      "minutes": 16,
      "method": "bus or taxi"
     }
    },
    {
     "kind": "afternoon",
     "area": "Higashiyama",
     "places": [
      {
       "id": "kiyomizu-dera",
       "name": "Kiyomizu-dera",
       "category": "culture",
       "area": "Higashiyama",
       "lat": 34.994303,
       "lng": 135.784439,
       "minutes": 90,
       "open": "06:00-18:00",
       "best": "06:00-08:30",
       "image": "/places/kiyomizu-dera.jpg",
       "city": "Kyoto"
      }
     ],
     "options": [],
     "times": [
      [
       "15:15",
       "16:45"
      ]
     ],
     "transit_next": {
      "minutes": 16,
      "method": "bus or taxi"
     }
    },
    {
     "kind": "evening",
     "area": "Gion",
     "places": [
      {
       "id": "shirakawa-minami-dori",
       "name": "Shirakawa-minami-dori",
       "category": "culture",
       "area": "Gion",
       "lat": 35.005358,
       "lng": 135.77294,
       "minutes": 30,
       "open": "00:00-23:59",
       "best": "16:30-19:00",
       "image": "/places/shirakawa-minami-dori.jpg",
       "city": "Kyoto"
      }
     ],
     "options": [],
     "times": [
      [
       "17:10",
       "17:40"
      ]
     ],
     "transit_next": {
      "minutes": 3,
      "method": "walk"
     }
    },
    {
     "kind": "evening",
     "area": "Nakagyo",
     "places": [
      {
       "id": "pontocho-alley",
       "name": "Pontocho Alley",
       "category": "nightlife",
       "area": "Central Kyoto: Nishiki & Pontocho",
       "lat": 35.004246,
       "lng": 135.771213,
       "minutes": 30,
       "open": "00:00-24:00",
       "best": "17:30-20:00",
       "image": "/places/pontocho-alley.jpg",
       "city": "Kyoto"
      },
      {
       "id": "atlantis",
       "name": "Atlantis",
       "category": "nightlife",
       "area": "Central Kyoto: Nishiki & Pontocho",
       "lat": 35.004154,
       "lng": 135.771271,
       "minutes": 75,
       "open": "18:00-01:00",
       "best": "18:00-23:00",
       "image": "/places/atlantis.jpg",
       "city": "Kyoto"
      },
      {
       "id": "bees-knees",
       "name": "Bees Knees",
       "category": "nightlife",
       "area": "Central Kyoto: Nishiki & Pontocho",
       "lat": 35.00506,
       "lng": 135.770306,
       "minutes": 75,
       "open": "18:00-02:00",
       "best": "18:00-01:00",
       "image": "/places/bees-knees.jpg",
       "city": "Kyoto"
      }
     ],
     "options": [],
     "times": [
      [
       "17:50",
       "18:20"
      ],
      [
       "18:30",
       "19:45"
      ],
      [
       "20:30",
       "21:45"
      ]
     ],
     "transit_next": null
    },
    {
     "kind": "dinner",
     "area": "Nakagyo",
     "places": [],
     "options": [
      {
       "id": "chao-chao-gyoza",
       "name": "Chao Chao Gyoza",
       "category": "food",
       "area": "Central Kyoto: Nishiki & Pontocho",
       "lat": 35.00856,
       "lng": 135.770905,
       "minutes": 55,
       "open": "17:00-23:00",
       "best": "17:00-18:00",
       "image": "/places/chao-chao-gyoza.jpg",
       "city": "Kyoto"
      }
     ],
     "times": [
      [
       null,
       null
      ]
     ],
     "transit_next": null
    }
   ]
  },
  {
   "n": 6,
   "date": "2026-05-10",
   "city": "Kyoto",
   "title": "Sakyo",
   "blocks": [
    {
     "kind": "morning",
     "area": "Sakyo",
     "places": [
      {
       "id": "ginkakuji",
       "name": "Ginkakuji",
       "category": "culture",
       "area": "Philosopher's Path & Nanzen-ji",
       "lat": 35.0269,
       "lng": 135.798371,
       "minutes": 65,
       "open": "08:30-17:00",
       "best": "08:30-10:00",
       "image": "/places/ginkakuji.jpg",
       "city": "Kyoto"
      }
     ],
     "options": [],
     "times": [
      [
       "08:30",
       "09:35"
      ]
     ],
     "transit_next": {
      "minutes": 17,
      "method": "transit · check route"
     }
    },
    {
     "kind": "morning",
     "area": "Philosopher's Path & Nanzen-ji",
     "places": [
      {
       "id": "murin-an-garden",
       "name": "Murin-an Garden",
       "category": "hidden_gem",
       "area": "Philosopher's Path & Nanzen-ji",
       "lat": 35.011551,
       "lng": 135.787266,
       "minutes": 60,
       "open": "09:00-17:00",
       "best": "09:00-11:00",
       "image": "/places/murin-an-garden.jpg",
       "city": "Kyoto"
      }
     ],
     "options": [],
     "times": [
      [
       "10:00",
       "11:00"
      ]
     ],
     "transit_next": {
      "minutes": 6,
      "method": "walk"
     }
    },
    {
     "kind": "morning",
     "area": "Sakyo",
     "places": [
      {
       "id": "nanzen-ji",
       "name": "Nanzen-ji",
       "category": "culture",
       "area": "Philosopher's Path & Nanzen-ji",
       "lat": 35.011114,
       "lng": 135.792512,
       "minutes": 90,
       "open": "08:40-17:00",
       "best": "08:40-10:00",
       "image": "/places/nanzen-ji.jpg",
       "city": "Kyoto"
      }
     ],
     "options": [],
     "times": [
      [
       "11:15",
       "12:45"
      ]
     ],
     "transit_next": null
    },
    {
     "kind": "lunch",
     "area": "Sakyo",
     "places": [],
     "options": [
      {
       "id": "nanzenji-junsei",
       "name": "Nanzenji Junsei",
       "category": "food",
       "area": "Philosopher's Path & Nanzen-ji",
       "lat": 35.011287,
       "lng": 135.79024,
       "minutes": 85,
       "open": "11:00-15:30,17:00-21:30",
       "best": "11:00-14:30",
       "image": "/places/nanzenji-junsei.jpg",
       "city": "Kyoto"
      }
     ],
     "times": [
      [
       null,
       null
      ]
     ],
     "transit_next": {
      "minutes": 23,
      "method": "transit · check route"
     }
    },
    {
     "kind": "afternoon",
     "area": "Sakyo",
     "places": [
      {
       "id": "enko-ji-temple",
       "name": "Enko-ji Temple",
       "category": "hidden_gem",
       "area": "Ichijoji",
       "lat": 35.044975,
       "lng": 135.797305,
       "minutes": 60,
       "open": "09:00-17:00",
       "best": "09:00-17:00",
       "image": "/places/enko-ji-temple.jpg",
       "city": "Kyoto"
      }
     ],
     "options": [],
     "times": [
      [
       "14:50",
       "15:50"
      ]
     ],
     "transit_next": null
    },
    {
     "kind": "dinner",
     "area": "Sakyo",
     "places": [],
     "options": [
      {
       "id": "omen-ginkakuji-honten",
       "name": "Omen Ginkakuji Honten",
       "category": "food",
       "area": "Jodoji",
       "lat": 35.026164,
       "lng": 135.79495,
       "minutes": 55,
       "open": "10:30-16:00,17:00-20:30",
       "best": "10:30-14:00",
       "image": null,
       "city": "Kyoto"
      },
      {
       "id": "mishima-tei",
       "name": "Mishima-tei",
       "category": "food",
       "area": "Central Kyoto: Nishiki & Pontocho",
       "lat": 35.008436,
       "lng": 135.767077,
       "minutes": 120,
       "open": "11:00-20:30",
       "best": "17:00-19:30",
       "image": "/places/mishima-tei.jpg",
       "city": "Kyoto"
      }
     ],
     "times": [
      [
       null,
       null
      ],
      [
       null,
       null
      ]
     ],
     "transit_next": null
    }
   ]
  },
  {
   "n": 7,
   "date": "2026-05-11",
   "city": "Kyoto",
   "title": "Arashiyama",
   "blocks": [
    {
     "kind": "morning",
     "area": "Arashiyama",
     "places": [
      {
       "id": "bamboo-forest",
       "name": "Bamboo Forest",
       "category": "popular",
       "area": "Arashiyama",
       "lat": 35.017105,
       "lng": 135.672283,
       "minutes": 35,
       "open": "00:00-24:00",
       "best": "06:00-08:30",
       "image": "/places/bamboo-forest.jpg",
       "city": "Kyoto"
      },
      {
       "id": "tenryu-ji",
       "name": "Tenryu-ji",
       "category": "culture",
       "area": "Arashiyama",
       "lat": 35.016224,
       "lng": 135.672941,
       "minutes": 55,
       "open": "08:30-17:00",
       "best": "08:30-10:00",
       "image": "/places/tenryu-ji.jpg",
       "city": "Kyoto"
      }
     ],
     "options": [],
     "times": [
      [
       "08:00",
       "08:35"
      ],
      [
       "08:45",
       "09:40"
      ]
     ],
     "transit_next": {
      "minutes": 34,
      "method": "bus or taxi"
     }
    },
    {
     "kind": "morning",
     "area": "Kita Ward",
     "places": [
      {
       "id": "genko-an",
       "name": "Genko-an",
       "category": "hidden_gem",
       "area": "Takagamine",
       "lat": 35.054842,
       "lng": 135.731817,
       "minutes": 45,
       "open": "09:00-17:00",
       "best": "09:00-11:00",
       "image": "/places/genko-an.jpg",
       "city": "Kyoto"
      },
      {
       "id": "kinkakuji",
       "name": "Kinkakuji",
       "category": "culture",
       "area": "Kita Ward",
       "lat": 35.039529,
       "lng": 135.729537,
       "minutes": 45,
       "open": "09:00-17:00",
       "best": "09:00-10:00",
       "image": "/places/kinkakuji.jpg",
       "city": "Kyoto"
      }
     ],
     "options": [],
     "times": [
      [
       "10:25",
       "11:10"
      ],
      [
       "11:35",
       "12:20"
      ]
     ],
     "transit_next": null
    },
    {
     "kind": "lunch",
     "area": "Kita Ward",
     "places": [],
     "options": [
      {
       "id": "ryoanji-saigetsu-in-yudofu",
       "name": "Seigen-in Yudofu at Ryoan-ji",
       "category": "food",
       "area": "Kita Ward",
       "lat": 35.033633,
       "lng": 135.717911,
       "minutes": 60,
       "open": "11:00-15:30",
       "best": "11:00-14:30",
       "image": null,
       "city": "Kyoto"
      }
     ],
     "times": [
      [
       null,
       null
      ]
     ],
     "transit_next": {
      "minutes": 30,
      "method": "bus or taxi"
     }
    },
    {
     "kind": "afternoon",
     "area": "Arashiyama",
     "places": [
      {
       "id": "rangetsu",
       "name": "Rangetsu",
       "category": "special",
       "area": "Arashiyama",
       "lat": 35.013567,
       "lng": 135.675464,
       "minutes": 60,
       "open": "00:00-24:00",
       "best": null,
       "image": null,
       "city": "Kyoto"
      }
     ],
     "options": [],
     "times": [
      [
       "15:00",
       "16:00"
      ]
     ],
     "transit_next": null
    },
    {
     "kind": "dinner",
     "area": "Arashiyama",
     "places": [],
     "options": [
      {
       "id": "rangetsu",
       "name": "Rangetsu",
       "category": "special",
       "area": "Arashiyama",
       "lat": 35.013567,
       "lng": 135.675464,
       "minutes": 60,
       "open": "00:00-24:00",
       "best": null,
       "image": null,
       "city": "Kyoto"
      }
     ],
     "times": [
      [
       "15:00",
       "16:00"
      ]
     ],
     "transit_next": null
    }
   ]
  },
  {
   "n": 8,
   "date": "2026-05-12",
   "city": "Kyoto",
   "title": "One Golden Hall Before the Train",
   "blocks": [
    {
     "kind": "morning",
     "area": "Higashiyama",
     "places": [
      {
       "id": "sanjusangendo",
       "name": "Sanjusangendo",
       "category": "culture",
       "area": "Higashiyama",
       "lat": 34.988172,
       "lng": 135.771778,
       "minutes": 60,
       "open": "08:30-17:00",
       "best": "08:30-10:30",
       "image": "/places/sanjusangendo.jpg",
       "city": "Kyoto"
      }
     ],
     "options": [],
     "times": [
      [
       "08:45",
       "09:45"
      ]
     ],
     "transit_next": null
    },
    {
     "kind": "travel",
     "label": "Kyoto → KIX",
     "text": "To KIX — leave Kyoto by 11:45 — train to Osaka first"
    }
   ]
  }
 ],
 "catalog": [
  {
   "id": "teamlab-borderless",
   "name": "teamLab Borderless",
   "city": "Tokyo",
   "category": "special",
   "area": "Azabudai",
   "lat": 35.662002,
   "lng": 139.743418,
   "minutes": 150,
   "openWeek": {
    "mon": "08:30-21:00",
    "tue": "08:30-21:00",
    "wed": "08:30-21:00",
    "thu": "08:30-21:00",
    "fri": "08:30-21:00",
    "sat": "08:30-21:00",
    "sun": "08:30-21:00"
   },
   "best": "08:30-11:00",
   "image": "/places/teamlab-borderless.jpg"
  },
  {
   "id": "tsukiji-outer-market",
   "name": "Tsukiji Outer Market",
   "city": "Tokyo",
   "category": "popular",
   "area": "Tsukiji Outer Market",
   "lat": 35.665388,
   "lng": 139.770473,
   "minutes": 90,
   "openWeek": {
    "mon": "05:00-14:00",
    "tue": "05:00-14:00",
    "wed": "closed",
    "thu": "05:00-14:00",
    "fri": "05:00-14:00",
    "sat": "05:00-14:00",
    "sun": "closed"
   },
   "best": "07:30-10:30",
   "image": "/places/tsukiji-outer-market.jpg"
  },
  {
   "id": "nishiki-market",
   "name": "Nishiki Market",
   "city": "Kyoto",
   "category": "food",
   "area": "Central Kyoto: Nishiki & Pontocho",
   "lat": 35.005024,
   "lng": 135.76557,
   "minutes": 60,
   "openWeek": {
    "mon": "10:00-18:00",
    "tue": "10:00-18:00",
    "wed": "10:00-18:00",
    "thu": "10:00-18:00",
    "fri": "10:00-18:00",
    "sat": "10:00-18:00",
    "sun": "10:00-18:00"
   },
   "best": "10:00-12:00",
   "image": "/places/nishiki-market.jpg"
  },
  {
   "id": "kiyomizu-dera",
   "name": "Kiyomizu-dera",
   "city": "Kyoto",
   "category": "culture",
   "area": "Higashiyama",
   "lat": 34.994303,
   "lng": 135.784439,
   "minutes": 75,
   "openWeek": {
    "mon": "06:00-18:00",
    "tue": "06:00-18:00",
    "wed": "06:00-18:00",
    "thu": "06:00-18:00",
    "fri": "06:00-18:00",
    "sat": "06:00-18:00",
    "sun": "06:00-18:00"
   },
   "best": "06:00-08:30",
   "image": "/places/kiyomizu-dera.jpg"
  },
  {
   "id": "karaoke-pasela-shinjuku-honten",
   "name": "Karaoke Pasela Shinjuku Honten",
   "city": "Tokyo",
   "category": "nightlife",
   "area": "Kabukicho, Shinjuku",
   "lat": 35.694328,
   "lng": 139.703934,
   "minutes": 120,
   "openWeek": {
    "mon": "00:00-24:00",
    "tue": "00:00-24:00",
    "wed": "00:00-24:00",
    "thu": "00:00-24:00",
    "fri": "00:00-24:00",
    "sat": "00:00-24:00",
    "sun": "00:00-24:00"
   },
   "best": "19:00-22:00",
   "image": null
  },
  {
   "id": "daikokuyu-oshiage-onsen",
   "name": "Daikokuyu Oshiage Onsen",
   "city": "Tokyo",
   "category": "hidden_gem",
   "area": "Oshiage",
   "lat": 35.70502,
   "lng": 139.81364,
   "minutes": 90,
   "openWeek": {
    "mon": "15:00-10:00",
    "tue": "closed",
    "wed": "15:00-10:00",
    "thu": "15:00-10:00",
    "fri": "15:00-10:00",
    "sat": "14:00-10:00",
    "sun": "13:00-10:00"
   },
   "best": "19:00-23:00",
   "image": null
  },
  {
   "id": "fushimi-inari-taisha",
   "name": "Fushimi Inari Taisha",
   "city": "Kyoto",
   "category": "culture",
   "area": "Fushimi Inari",
   "lat": 34.967142,
   "lng": 135.773236,
   "minutes": 120,
   "openWeek": {
    "mon": "00:00-24:00",
    "tue": "00:00-24:00",
    "wed": "00:00-24:00",
    "thu": "00:00-24:00",
    "fri": "00:00-24:00",
    "sat": "00:00-24:00",
    "sun": "00:00-24:00"
   },
   "best": "05:30-09:00",
   "image": "/places/fushimi-inari-taisha.jpg"
  },
  {
   "id": "uji-byodo-in",
   "name": "Uji & Byodo-in",
   "city": "Kyoto",
   "category": "culture",
   "area": "Uji, Kyoto",
   "lat": 34.8895001,
   "lng": 135.8074525,
   "minutes": 180,
   "openWeek": {
    "mon": "08:45-17:30",
    "tue": "08:45-17:30",
    "wed": "08:45-17:30",
    "thu": "08:45-17:30",
    "fri": "08:45-17:30",
    "sat": "08:45-17:30",
    "sun": "08:45-17:30"
   },
   "best": "08:45-17:30",
   "image": "/places/uji-byodo-in.jpg"
  }
 ]
};

export default AGENDA_DEMO;
